// @flow

import ApiObject from '../ApiObject';
import MenuPartItemType from './MenuPartItemType';

export default class MenuPartItem extends ApiObject {

  // shortcut
  static Type = MenuPartItemType;

  id: string;

  type: MenuPartItemType;
  //
  //
  //

  static fromProduct(product) {
    return new MenuPartItem().fromJson({
      id: product.id,
      type: MenuPartItemType.PRODUCT,
    });
  }

  static fromCategory(category) {
    return new MenuPartItem().fromJson({
      id: category.id,
      type: MenuPartItemType.CATEGORY,
    });
  }

  //
  //
  //

  isProduct(): boolean {
    return this.type === MenuPartItemType.PRODUCT;
  }

  isCategory(): boolean {
    return this.type === MenuPartItemType.CATEGORY;
  }
}
